export default "__VITE_ASSET__640be691__"